(function () {
  'use strict';

  var STICKY_COOKIE = 'montroyal_newsletter_dismissed';
  var CONSENT_COOKIE = 'montroyal_consent';
  var SHOW_DELAY_MS = 8000;

  function getCookie(name) {
    var m = ('; ' + document.cookie).match(new RegExp(';\\s*' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + date.toGMTString() + '; path=/; SameSite=Lax';
  }

  function dismiss(el, days) {
    setCookie(STICKY_COOKIE, '1', days || 30);
    el.hidden = true;
  }

  function init() {
    var el = document.getElementById('montroyal-newsletter-sticky');
    if (!el) return;

    // If user just successfully submitted, set long dismissal and stay visible briefly to show confirmation
    if (el.querySelector('[data-newsletter-success]')) {
      setCookie(STICKY_COOKIE, '1', 365);
      el.hidden = false;
      setTimeout(function () { el.hidden = true; }, 4000);
      return;
    }

    // Already dismissed → don't show
    if (getCookie(STICKY_COOKIE)) return;

    // Cookie consent banner takes priority — don't show until user has given consent
    if (!getCookie(CONSENT_COOKIE)) return;

    // Show after delay
    setTimeout(function () {
      el.hidden = false;
      el.setAttribute('data-state', 'open');
    }, SHOW_DELAY_MS);

    // Close button
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-newsletter-close]')) {
        dismiss(el, 30);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
